import { createServerFn } from "@tanstack/react-start";

import { setRouteAction } from "#/lib/requestLogger.server";
import { archiveMonthKeyInputSchema } from "#/lib/serverInputSchemas";
import { buildCalendarMonthBucket } from "#/server/game/archiveCalendarMonth";
import { toUtcDateString } from "#/server/game/dailyMapIds";

export const loadArchiveMonthCalendar = createServerFn({ method: "GET" })
  .validator(archiveMonthKeyInputSchema)
  .handler(async ({ data }) => {
    setRouteAction("archive_month_calendar");
    const todayStr = toUtcDateString(new Date());
    return buildCalendarMonthBucket({ monthKey: data.monthKey, todayStr });
  });
